import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ConfirmDialogService } from '../../dialog/confirm-dialog/confirm-dialog.service';
import { JournalProcessDefinitionService } from './journalprocessdefinition.service';

/** Dependencies required to run the shared journal process definition delete flow. */
export interface DeleteJournalProcessDefinitionOptions {
  /** Id of the journal process definition to delete. */
  id: string;
  service: JournalProcessDefinitionService;
  dialogService: ConfirmDialogService;
  destroyRef: DestroyRef;
  /** Called after the journal process definition has been removed successfully. */
  onDeleted: () => void;
}

/**
 * Runs the shared "Verwijderen" flow for a journal process definition.
 *
 * There is no reference from other records to a journal process definition
 * (per the data model), so no dependency check is needed — we only ask for
 * confirmation before deleting.
 */
export function deleteJournalProcessDefinitionWithConfirm(
  options: DeleteJournalProcessDefinitionOptions,
): void {
  const { id, service, dialogService, destroyRef, onDeleted } = options;

  dialogService.open({
    width: '320px',
    title: 'Verwijderen?',
    message: 'Verwerkingsdefinitie verwijderen?',
    cancelText: 'Nee',
    confirmText: 'Ja',
    variant: 'error',
  });

  dialogService
    .confirmed()
    .pipe(
      take(1),
      switchMap((confirmed) => {
        if (!confirmed) {
          return EMPTY;
        }

        return service.removeJournalProcessDefinition(id);
      }),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe({
      next: () => onDeleted(),
      error: () => undefined,
    });
}
